$(document).on('turbolinks:load', function () {

  var userSelectallOrgs = $('#holiday-selectall-orgs');
  if (userSelectallOrgs.length) {
    userSelectallOrgs.click(function() {
      if(this.checked) {
        $('input[id^="holiday_location_ids_"]').each(function(){
          this.checked = true;
        });
      } else {
        $('input[id^="holiday_location_ids_"]').each(function(){
          this.checked = false;
        });
      } 
    });
  }

});